module.exports = __webpack_public_path__ + "img/horizontal_6_5_9016.23f8480e.png";